import request from "./request";

export {PersonalShopperError} from "./request";

const BASE = "/personal_shopper";

export function listConversations({page = 1, search = "", status = "", held = false, escalated = false, expiring = false, suspended = false, erasureRequested = false} = {}) {
    // status: one of the list's tabs (to_handle, open, converted), empty for all of them.
    return request(`${BASE}/conversations`, {
        query: {page, q: search, status: status || "", held: held ? 1 : "", escalated: escalated ? 1 : "", expiring: expiring ? 1 : "", suspended: suspended ? 1 : "", erasureRequested: erasureRequested ? 1 : ""},
    });
}

export function getConversation(id) {
    return request(`${BASE}/conversations/${id}`);
}

export function getMessages(id, afterId = 0) {
    // signal: null — the poll must not be cancelled by the navigation abort of the page's other GETs.
    return request(`${BASE}/conversations/${id}/messages`, {query: {after: afterId}, signal: null});
}

export function takeOver(id, force = false) {
    // The API refuses anything but a real boolean, so that "false" can never read as true.
    return request(`${BASE}/conversations/${id}/takeover`, {method: "POST", body: {force: force === true}});
}

export function release(id) {
    return request(`${BASE}/conversations/${id}/release`, {method: "POST"});
}

export function reply(id, text) {
    return request(`${BASE}/conversations/${id}/messages`, {method: "POST", body: {text}});
}

export function searchProducts({query, gender = "", brands = "", sizes = "", colors = "", priceMin = "", priceMax = ""} = {}) {
    // The shop's catalogue as the assistant searches it: read live from Sylius.
    return request(`${BASE}/products`, {query: {q: query, gender, brands, sizes, colors, price_min: priceMin, price_max: priceMax}});
}

export function sendProducts(id, codes) {
    // One card per code, in that order; answers the cards as messages.
    return request(`${BASE}/conversations/${id}/products`, {method: "POST", body: {codes}});
}

export function handleEscalation(escalationId) {
    return request(`${BASE}/escalations/${escalationId}/handle`, {method: "POST"});
}

export function putFact(id, label, value) {
    return request(`${BASE}/conversations/${id}/facts/${encodeURIComponent(label)}`, {method: "PUT", body: {value}});
}

export function deleteFact(id, label) {
    return request(`${BASE}/conversations/${id}/facts/${encodeURIComponent(label)}`, {method: "DELETE"});
}

export function setMarketingOptOut(id, optedOut) {
    // A real boolean only: the API refuses anything else.
    return request(`${BASE}/conversations/${id}/marketing-opt-out`, {method: "PUT", body: {optedOut: optedOut === true}});
}

export function suspend(id, reason) {
    return request(`${BASE}/conversations/${id}/suspend`, {method: "POST", body: {reason}});
}

export function reactivate(id) {
    return request(`${BASE}/conversations/${id}/reactivate`, {method: "POST"});
}

export function getPersonalData(id) {
    return request(`${BASE}/conversations/${id}/personal-data`);
}

export function erase(id) {
    return request(`${BASE}/conversations/${id}`, {method: "DELETE"});
}

export function getStatistics({days = 30, from = "", to = ""} = {}) {
    // from/to (ISO 8601): a window of the person's own, read live from Sylius; else the mirrored snapshot.
    return request(`${BASE}/statistics`, {query: from ? {from, to: to || ""} : {days}});
}
